<template>
	<div class="toast">{{title}}</div>
</template>

<script>
	export default {
	  name: 'toast',
	  data(){
		  return{
			  title:"111"
		  }
	  },
    created() {
      console.log(this.title)
    }
	}
</script>

<style>
	.toast{
		color: #FFFFFF;
		font-size: 20px;

    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 102;
	}
</style>



// WEBPACK FOOTER //
// src/components/toastInfo/toastInfo.vue